module.exports = __webpack_public_path__ + "static/media/profile.53a87648.webp";